
import { View }         from 'backbone';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import listService      from 'ListService.js';
import Template         from 'behaviors/properties/main/start-stop.ejs';
import widgetUtil       from 'util/WidgetUtil.js';
//=====================================================================
//
// An instance of this view represents a start stop.
//
// Casey Justus, June 3, 2016 
//
//=====================================================================

class MainStartStopView extends View {


    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #selectObject'           : 'selectObject',
            'change input[type=radio]'      : 'updateAttributes'
        };

        if (this.model.get('controlId')) {
            const id = this.model.get('controlId');
            const obj = listService.getObject( listService.cleanId(id) );
            const objName = obj ? obj.model.get('name') : '';
            this.model.set('selectedObjectName', objName, {silent:true});
        }

        this.listenTo(this.model, 'change', this.render);

        return this;
    }
    
    selectObject(ev){
        console.log('selectObject');
        this.model.set("dataSelectedItemId", this.model.get("controlId"), {silent:true});

        var sfModal = new selectFieldModalView({model: this.model, mode: 'objectsANDlists'});
        sfModal.render().then((selectedField)=>{
            this.model.set('controlId', selectedField.id, {silent:true});
            this.model.set('selectedObjectName', selectedField.name);
            this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ) ;

        }).catch(err => console.log(err));
    }

   updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
        this.render();
    }

    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
       
        $("input:radio[value='"+this.model.get('action')+"']").attr('checked', true);

        this.delegateEvents();
        return this;
    }

}

export default MainStartStopView;
